import { Application } from "app/client/store";
import { observer } from "mobx-react";
import React, { useState } from "react";
import Button from "../../ui/button";
import CloseButton from "../../ui/close-button";
import { Modal } from "../../ui/modal";
import { when } from "../../util/when";
// Styles
import "./account.scss";
interface ICancelSubscriptionModalProps {
  setCancelSubscriptionModalOpen(open: boolean): void;
}
export const CancelSubscriptionModal: React.FC<ICancelSubscriptionModalProps> =
  observer(({ setCancelSubscriptionModalOpen }) => {
    const [success, setSuccess] = useState(false);
    const [cancelReason, setCancelReason] = useState<string>("");
    const [otherReason, setOtherReason] = useState<string>("");
    const [showCancelReason, setShowCancelReason] = useState(false);
    const cancelReasons = [
      "Too expensive",
      "Not using enough",
      "Found a better alternative",
      "Other",
    ];

    function handleCancelReasonChange(e: React.ChangeEvent<HTMLInputElement>) {
      setCancelReason(e.target.value);
      if (e.target.value !== "Other") {
        setOtherReason("");
      }
    }

    function handleOtherReasonChange(e: React.ChangeEvent<HTMLInputElement>) {
      setOtherReason(e.target.value);
      setCancelReason("Other");
    }

    function submitCancelSubscription() {
      const reason = cancelReason === "Other" ? otherReason : cancelReason;
      handleCancelSubscription(reason);
    }
    const handleCancelSubscription = async (reason: string) => {
      try {
        await Application.ui.account.cancelSubscription(reason);
        setSuccess(true);
      } catch (error) {
        console.error(error);
      }
    };
    return (
      <>
        <Modal onClose={() => setCancelSubscriptionModalOpen(false)}>
          {when(
            success,
            <div className="ModalContainer">
              <CloseButton
                onClick={() => setCancelSubscriptionModalOpen(false)}
              />
              <div className="ModalContainer-title">
                Successfully cancelled membership
              </div>
              <div className="ModalContainer-content">
                Your membership has been successfully cancelled.
              </div>
              <div className="ModalContainer-actions">
                <Button
                  label="Return to account"
                  onClick={() => setCancelSubscriptionModalOpen(false)}
                  style="blue"
                />
              </div>
            </div>
          )}
          {when(
            !success,
            <div className="ModalContainer">
              <CloseButton
                onClick={() => setCancelSubscriptionModalOpen(false)}
              />
              <div className="ModalContainer-title">Cancel Membership</div>
              {when(
                !showCancelReason,
                <div className="ModalContainer-content">
                  Are you sure you want to cancel your membership?
                  <div>
                    <Button
                      label="Yes,I'm sure"
                      onClick={() => setShowCancelReason(true)}
                      style="blue"
                    />
                    <Button
                      label="No, I changed my mind"
                      onClick={() => setCancelSubscriptionModalOpen(false)}
                      style="default"
                    />
                  </div>
                </div>
              )}
              {when(
                showCancelReason,
                <div className="ModalContainer-actions">
                  <div style={{ marginBottom: 16 }}>
                    <div style={{ fontWeight: 500, marginBottom: 8 }}>
                      Why are you cancelling?
                    </div>
                    {cancelReasons.map((reason) => (
                      <div key={reason} style={{ marginBottom: 4 }}>
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <input
                            type="radio"
                            name="cancel-reason"
                            value={reason}
                            checked={cancelReason === reason}
                            onChange={handleCancelReasonChange}
                            style={{ marginRight: 8 }}
                          />
                          {reason}
                          {reason === "Other" && cancelReason === "Other" && (
                            <input
                              type="text"
                              placeholder="Please specify"
                              value={otherReason}
                              onChange={handleOtherReasonChange}
                              style={{
                                marginLeft: 8,
                                flex: 1,
                                padding: 4,
                              }}
                            />
                          )}
                        </label>
                      </div>
                    ))}
                    <Button
                      label="Submit cancellation"
                      onClick={submitCancelSubscription}
                      style="blue"
                      disabled={cancelReason === ""}
                    />
                    <Button
                      label="Go back"
                      onClick={() => setShowCancelReason(false)}
                      style="default"
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </Modal>
      </>
    );
  });
